import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: '',
    main: [
      {
        state: 'dashboard',
        short_label: 'D',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },
      {
        state: 'reports',
        short_label: 'R',
        name: 'Reports',
        type: 'sub',
        icon: 'ti-bar-chart',
        children: [
          {
            state: 'evaluation-coverage',
            name: 'Encounter Coverage'
          },
          {
            state: 'evaluation-scores',
            name: 'Encounter Scores'
          },
          {
            state: 'evaluation-consent',
            name: 'Encounter Consent'
          },
          {
            state: 'evaluation-details',
            name: 'Encounter Details'
          },
          {
            state: 'feedback-percentage',
            name: 'Feedback %'
          },
          {
            state: 'feedback-scores',
            name: 'Feedback Scores'
          },
          {
            state: 'feedback-details',
            name: 'Feedback Details'
          }
        ]
      },
      {
        state: 'question-management',
        short_label: 'Q',
        name: 'Question Mgmt',
        type: 'sub',
        icon: 'ti-pencil-alt',
        children: [
          {
            state: 'supervisor-evaluation',
            name: 'Supervisor Encounter'
          }, {
            state: 'employee-response',
            name: 'Employee Response'
          }
        ]
      },
      {
        state: 'site-management',
        short_label: 'S',
        name: 'Site Mgmt',
        type: 'sub',
        icon: 'ti-settings',
        children: [
          {
            state: 'mobile-management',
            name: 'Mobile Management'
          }, {
            state: 'user-management',
            name: 'User Management'
          }, {
            state: 'system-management',
            name: 'System Management'
          }
        ]
      }
    ]
  }
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }
}
